import React from "react";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { SiBluesky } from "@icons-pack/react-simple-icons";

export default function Footer() {
  return (
    <footer style={{
      background: "linear-gradient(90deg, #234a94, #305DBD)",
      color: "#fff",
      padding: "36px 48px 20px",
      marginTop: "auto",
    }}>
      {/* Main grid — collapses to a single column on small screens via the
          CSS class below (inline styles can't media-query, so the grid
          itself stays as a sensible default and .dshb-footer-grid in the
          <style> tag overrides it under the breakpoint). */}
      <div className="dshb-footer-grid" style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: "32px",
        marginBottom: "28px",
      }}>
        {/* Column 1 — DSHB */}
        <div>
          <p style={{ fontWeight: 700, fontSize: "14px", letterSpacing: "0.08em", textTransform: "uppercase", color: "#8FBCFF", marginBottom: "10px" }}>
            DSHB
          </p>
          <p style={{ fontSize: "13px", color: "#E1E9FC", lineHeight: 1.7, marginBottom: "6px" }}>
            Developmental Studies Hybridoma Bank
          </p>
          <p style={{ fontSize: "13px", color: "#E1E9FC", lineHeight: 1.7, marginBottom: "4px" }}>
            University of Iowa
          </p>
          <p style={{ fontSize: "13px", color: "#E1E9FC", lineHeight: 1.7 }}>
            Iowa City, IA 52242
          </p>
        </div>

        {/* Column 2 — Contact */}
        <div>
          <p style={{ fontWeight: 700, fontSize: "14px", letterSpacing: "0.08em", textTransform: "uppercase", color: "#8FBCFF", marginBottom: "10px" }}>
            Contact
          </p>
          <p style={{ fontSize: "13px", color: "#E1E9FC", marginBottom: "6px" }}>
            📞 (319) 335-3826
          </p>
          <p style={{ fontSize: "13px", color: "#E1E9FC", marginBottom: "6px" }}>
            ✉️{" "}
            <a href="mailto:dshb@uiowa.edu" style={{ color: "#8FBCFF", textDecoration: "none" }}>
              dshb@uiowa.edu
            </a>
          </p>
          <p style={{ fontSize: "13px", color: "#E1E9FC" }}>
            🌐{" "}
            <a href="https://dshb.biology.uiowa.edu" target="_blank" rel="noreferrer"
              style={{ color: "#8FBCFF", textDecoration: "none" }}>
              dshb.biology.uiowa.edu
            </a>
          </p>
        </div>

        {/* Column 3 — Follow Us */}
        <div>
          <p style={{ fontWeight: 700, fontSize: "14px", letterSpacing: "0.08em", textTransform: "uppercase", color: "#8FBCFF", marginBottom: "10px" }}>
            Follow Us
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <a href="https://www.facebook.com/DSHBUI" target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "8px", color: "#E1E9FC", textDecoration: "none", fontSize: "13px" }}>
              <FaFacebookF style={{ color: "#8FBCFF", fontSize: "14px" }} /> Facebook
            </a>
            <a href="https://www.instagram.com/dshb_antibodies/" target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "8px", color: "#E1E9FC", textDecoration: "none", fontSize: "13px" }}>
              <FaInstagram style={{ color: "#8FBCFF", fontSize: "14px" }} /> Instagram
            </a>
            <a href="https://x.com/DSHB_antibodies" target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "8px", color: "#E1E9FC", textDecoration: "none", fontSize: "13px" }}>
              <FaTwitter style={{ color: "#8FBCFF", fontSize: "14px" }} /> X (Twitter)
            </a>
            <a href="https://bsky.app/profile/dshb-antibodies.bsky.social" target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "8px", color: "#E1E9FC", textDecoration: "none", fontSize: "13px" }}>
              <SiBluesky style={{ color: "#8FBCFF", width: "14px", height: "14px" }} /> Bluesky
            </a>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", marginBottom: "16px" }} />

      {/* Bottom row */}
      <div className="dshb-footer-bottom" style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "8px",
      }}>
        <p style={{ fontSize: "12px", color: "#C5D3F0", margin: 0 }}>
          © 1986 – {new Date().getFullYear()} Developmental Studies Hybridoma Bank · University of Iowa
        </p>
        <p className="dshb-footer-iowa" style={{
          fontFamily: "'Times New Roman', Georgia, serif",
          fontWeight: 1000,
          fontSize: "50px",
          letterSpacing: "2px",
          color: "#fff",
          margin: 0,
        }}>
          IOWA
        </p>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .dshb-footer-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .dshb-footer-bottom {
            flex-direction: column;
            align-items: flex-start !important;
            gap: 12px !important;
          }
          .dshb-footer-iowa {
            font-size: 36px !important;
          }
        }
        @media (max-width: 480px) {
          .dshb-footer-iowa {
            font-size: 28px !important;
          }
        }
      `}</style>
    </footer>
  );
}